<div
  class="hs-root"
  [style.left.px]="offsetLeft"
  [style.top.px]="offsetTop"
  [style.width.px]="width"
  [style.height.px]="height"
>
  <div
    class="hs-strip"
    *ngFor="let r of pxRegions; trackBy: trackByKey"
    [style.left.px]="r.left"
    [style.top.px]="r.top"
    [style.width.px]="r.width"
    [style.height.px]="r.height"
    (mouseenter)="hotspotHover.emit(r.key)"
    (mouseleave)="hotspotHover.emit(null)"
  ></div>
</div>
